/**
 * Returns the saved authentication token from the browser
 */
import {AuthenticationService} from "../services/api/authentication.service";

export function jwtTokenGetter() {
    return JSON.parse(localStorage.getItem(AuthenticationService.PERSISTENCE_USER_ACCOUNT_KEY))?.authToken;
}
